import { PLAN_KEY } from '../../constants'

function beforeSavePlanHook (data) {
  if (!data[PLAN_KEY.ID]) {
    return data
  }
  // If we're updating the data, do not send the workouts since they will get updated individually
  return {
    ...data,
    [PLAN_KEY.WORKOUTS]: []
  }
}

export default beforeSavePlanHook
